import React, { useState, useEffect } from 'react';

import { Tag } from './index'
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import { getTags } from '../actions/tags';
import { createTags, updateTag } from '../actions/tags';
import { useSelector } from 'react-redux';

type PropsFormTag = {
    currentTagId?: number;
    setCurrentTagId?: any;
};

const FormTag: React.FC<PropsFormTag> = ({ currentTagId, setCurrentTagId}) => {

    const [tagData, setTagData] = useState({ title: '', color: '' });
    
    const tag = useSelector((state: any) => currentTagId ? state.tags.find((p) => p._id === currentTagId) : null)
    const tags = useSelector((state: any) => state.tags)


    const dispatch = useDispatch();

    useEffect(() => {
        if(tag) setTagData(tag)
    }, [tag])

    const handleSubmitTag = (e: any) => {
        e.preventDefault();
        if (currentTagId) {
            dispatch(updateTag(currentTagId, tagData))
        } else {
            dispatch(createTags(tagData));
        }
        clearTag();
    }

    const handleChangeComplete = (color) => {
        setTagData({ ...tagData, color: color.hex })
    };
    
    const clearTag = () => {
        setCurrentTagId(null)
        setTagData({ title: '', color: ''});
    }

    useEffect(() => {
        dispatch(getTags())
    }, [currentTagId, dispatch])
    

    return (
        <form className="_shadow-xl _bg-white _rounded-card _p-md _w-auto" onSubmit={handleSubmitTag}>
            <h1 className="_text-center">{currentTagId ? 'Modifier' : 'Créer'} un Tag </h1>
                <div className="_flex _flex-col">
                    <input
                        className="_p-xs _rounded-md _my-sm _bg-gray"
                        type="text"
                        name="title"
                        value={tagData.title}
                        placeholder="Nom du tag"
                        onChange={(e) => setTagData({ ...tagData, title: e.target.value })}
                    />
                    <ChromePicker
                        width='100%'
                        color={ tagData.color }
                        onChangeComplete={ handleChangeComplete }
                    />
                
            </div>
            <section className="_flex _flex-col">
                <h1 className="_my-sm"> Liste des tags </h1>
                <div className="_flex _flex-wrap _p-sm _bg-gray _rounded-md">
                    {tags.map((tag, i) => {
                    // return <SwiperSlide onClick={ (e) => setIsDetails(!isDetails) } key={i}><Post isForm={isForm} setCurrentTagId={setCurrentTagId} isDetails={isDetails} key={post._id} post={post} /></SwiperSlide>
                        return <Tag isForm={true} setCurrentTagId={setCurrentTagId} key={tag._id} elements={tag} />
                    })}
                </div>
            </section>
            <div className="_flex _justify-end _mt-sm">
                <button type="reset" onClick={clearTag}>Annuler </button>
                <button type="submit" className="_ml-sm _bg-green _rounded-md hover:_bg-darkengreen _text-white _font-bold _py-xs _px-sm _rounded-lg">
                    {currentTagId ? 'Modifier' : 'Créer'}
                </button>
            </div>
        </form>
    );
    
};

export default FormTag;



